/* La Maison de la Hi-Fi — Liste de souhaits invitée (sans compte client)
   Stockage local (localStorage + cookie de secours), aucune donnée envoyee au serveur. */
(function () {
  var T = window.LmdhWishlistText || {};
  function txt(key, fallback) {
    return T[key] || fallback;
  }
  var KEY = 'lmdh_wishlist_v1';
  var COOKIE = 'lmdh_wishlist';
  var MAX = 60;

  function readCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function writeCookie(name, value) {
    var d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function load() {
    var raw = '';
    try {
      raw = window.localStorage.getItem(KEY) || '';
    } catch (e) {
      raw = '';
    }
    if (!raw) raw = readCookie(COOKIE);
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (i) { return i && i.handle; }) : [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    var raw = JSON.stringify(items.slice(0, MAX));
    try {
      window.localStorage.setItem(KEY, raw);
    } catch (e) {
      /* quota / navigation privee */
    }
    writeCookie(COOKIE, raw.length < 3500 ? raw : JSON.stringify(items.slice(0, 12)));
    document.dispatchEvent(new CustomEvent('lmdh:wishlist:change', { detail: { items: items } }));
  }

  var Wishlist = {
    items: load(),
    has: function (handle) {
      return this.items.some(function (i) { return i.handle === handle; });
    },
    add: function (item) {
      if (this.has(item.handle)) return;
      this.items.unshift(item);
      save(this.items);
    },
    remove: function (handle) {
      this.items = this.items.filter(function (i) { return i.handle !== handle; });
      save(this.items);
    },
    clear: function () {
      this.items = [];
      save(this.items);
    }
  };
  window.LmdhWishlist = Wishlist;

  var money = function (cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  function handleFromHref(href) {
    if (!href) return '';
    var m = href.split('?')[0].match(/\/products\/([^\/]+)/);
    return m ? m[1] : '';
  }

  /* ---------- rendu du tiroir ---------- */
  function render() {
    var drawer = document.getElementById('lmdh-wishlist-drawer');
    if (!drawer) return;
    var list = drawer.querySelector('[data-wishlist-list]');
    var empty = drawer.querySelector('[data-wishlist-empty]');
    var footer = drawer.querySelector('[data-wishlist-footer]');
    var items = Wishlist.items;

    if (!items.length) {
      list.innerHTML = '';
      empty.hidden = false;
      if (footer) footer.hidden = true;
    } else {
      empty.hidden = true;
      if (footer) footer.hidden = false;
      list.innerHTML = items
        .map(function (i) {
          var img = i.image
            ? '<img src="' + i.image + '" alt="" loading="lazy" width="90" height="90">'
            : '<span class="lmdh-wishlist__ph" aria-hidden="true"></span>';
          return (
            '<li class="lmdh-wishlist__item">' +
            '<a class="lmdh-wishlist__thumb" href="' + i.url + '">' + img + '</a>' +
            '<div class="lmdh-wishlist__info">' +
            '<a class="lmdh-wishlist__name" href="' + i.url + '">' + i.title + '</a>' +
            (i.vendor ? '<span class="lmdh-wishlist__vendor">' + i.vendor + '</span>' : '') +
            (typeof i.price === 'number' ? '<span class="lmdh-wishlist__price">' + money(i.price) + '</span>' : '') +
            '<a class="lmdh-wishlist__link" href="' + i.url + '">' + txt('view', 'Voir le produit') + '</a>' +
            '</div>' +
            '<button type="button" class="lmdh-wishlist__remove" data-wishlist-remove="' + i.handle + '" aria-label="' + txt('remove', 'Retirer de la liste de souhaits') + '">&times;</button>' +
            '</li>'
          );
        })
        .join('');
    }
    syncCount();
    syncButtons();
  }

  function syncCount() {
    var n = Wishlist.items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = Wishlist.has(btn.getAttribute('data-wishlist-toggle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        active ? txt('remove', 'Retirer de la liste de souhaits') : txt('add', 'Ajouter à la liste de souhaits')
      );
    });
  }

  /* ---------- ouverture / fermeture ---------- */
  function open() {
    var d = document.getElementById('lmdh-wishlist-drawer');
    if (!d) return;
    render();
    d.removeAttribute('hidden');
    /* Forcer un reflow pour que le panneau soit rendu a translateX(100%)
       avant de declencher la transition vers translateX(0). Sinon le
       navigateur affiche l'etat final sans animation. */
    void d.offsetWidth;
    d.classList.add('is-open');
    document.body.classList.add('lmdh-wishlist-open');
    var close = d.querySelector('[data-wishlist-close]');
    if (close) close.focus();
  }
  function close() {
    var d = document.getElementById('lmdh-wishlist-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('lmdh-wishlist-open');
    window.setTimeout(function () {
      if (!d.classList.contains('is-open')) d.setAttribute('hidden', '');
    }, 320);
  }
  window.LmdhWishlist.open = open;
  window.LmdhWishlist.close = close;

  /* ---------- boutons coeur sur les fiches et cartes produit ---------- */
  var heartSvg =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.7 4.3 13a4.8 4.8 0 0 1 0-6.8 4.8 4.8 0 0 1 6.8 0l.9.9.9-.9a4.8 4.8 0 0 1 6.8 6.8Z"/></svg>';

  function makeButton(handle, variant) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lmdh-wishlist-btn lmdh-wishlist-btn--' + variant;
    b.setAttribute('data-wishlist-toggle', handle);
    b.innerHTML = heartSvg + (variant === 'product' ? '<span>' + txt('add', 'Ajouter à ma liste de souhaits') + '</span>' : '');
    return b;
  }

  function injectCardButtons(root) {
    (root || document).querySelectorAll('.card-wrapper, .card, .grid__item .card__inner').forEach(function (card) {
      if (card.querySelector('.lmdh-wishlist-btn')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = handleFromHref(link && link.getAttribute('href'));
      if (!handle) return;
      var media = card.querySelector('.card__media, .card__inner') || card;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      media.appendChild(makeButton(handle, 'card'));
    });
  }

  function injectProductButton() {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.lmdh-wishlist-btn--product')) return;
    var handle = handleFromHref(window.location.pathname);
    if (!handle) return;
    form.insertAdjacentElement('afterend', makeButton(handle, 'product'));
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return { handle: handle, title: handle, url: '/products/' + handle };
        return {
          handle: handle,
          title: p.title,
          vendor: p.vendor,
          price: p.price,
          image: p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '',
          url: '/products/' + handle
        };
      })
      .catch(function () {
        return { handle: handle, title: handle, url: '/products/' + handle };
      });
  }

  /* ---------- evenements ---------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      var handle = toggle.getAttribute('data-wishlist-toggle');
      if (Wishlist.has(handle)) {
        Wishlist.remove(handle);
      } else {
        toggle.classList.add('is-loading');
        fetchProduct(handle).then(function (item) {
          toggle.classList.remove('is-loading');
          Wishlist.add(item);
          open();
        });
      }
      return;
    }
    var opener = event.target.closest('[data-wishlist-open]');
    if (opener) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('[data-wishlist-close]') || event.target.closest('[data-wishlist-overlay]')) {
      event.preventDefault();
      close();
      return;
    }
    var remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      Wishlist.remove(remove.getAttribute('data-wishlist-remove'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('lmdh:wishlist:change', render);

  function init() {
    /* Deplacer le tiroir sous <body> pour qu'il echappe au contexte
       d'empilement du sticky-header (z-index 20) ; sinon l'announcement-bar
       (z-index 101) masque la croix de fermeture en haut. */
    var drawer = document.getElementById('lmdh-wishlist-drawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    injectCardButtons();
    injectProductButton();
    render();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 50); });
  var mo = new MutationObserver(function () { injectCardButtons(); syncButtons(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
